export enum WhitelabelType {
  Organization = 'Organization',
  Whitelabel = 'Whitelabel',
}
